import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import { IDENTITY, NAV } from "../data/content";

export const Footer = () => {
  return (
  <footer data-testid="main-footer" className="border-t border-slate-800/60 bg-slate-950">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <span className="font-heading text-xl font-semibold text-white">
            Lucarne<span className="text-blue-500"> Ops</span>
          </span>
          <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-xs">
            {IDENTITY.tagline}
          </p>
          <p className="mt-4 text-slate-600 text-xs">SIREN {IDENTITY.siren}</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-4">Navigation</h4>
          <ul className="space-y-2">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-slate-400 hover:text-white text-sm transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-4">Contact</h4>
          <ul className="space-y-3">
            <li>
              <a href={`mailto:${IDENTITY.email}`} data-testid="footer-email" className="flex items-center gap-3 text-slate-400 hover:text-white text-sm transition-colors">
                <Mail size={16} className="text-blue-500" /> {IDENTITY.email}
              </a>
            </li>
            <li>
              <a href={IDENTITY.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="flex items-center gap-3 text-slate-400 hover:text-white text-sm transition-colors">
                <Linkedin size={16} className="text-blue-500" /> {IDENTITY.linkedinLabel}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-slate-800/60 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-slate-600 text-xs">© {new Date().getFullYear()} {IDENTITY.name} — Lucarne Ops. Tous droits réservés.</p>
        <p className="text-slate-600 text-xs">{IDENTITY.domain}</p>
      </div>
    </div>
  </footer>
  );
};
